import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { ICCService } from '../../icc.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { FleetConfiguration } from '../../model/fleet-configuration';
import { NetworkProfile } from '../../model/network-profile';

let $ = require('jquery');
let _ = require('lodash');

@Component({
  selector: 'select-vc-dc',
  styles: [require('../../icc.scss')],
  template: require('./select-vc-dc.html'),
  providers: [
    ICCService, TranslateService
  ]
})

export class SelectVCDC {

    @Input() fleetConfig: FleetConfiguration;
    @Input() isWizardOpen: boolean = false;
    @Input() isEdit: boolean = false;
    @Input() errorFlag: boolean;
    @Input() errorMessage: string;
    @Output() validateResourceConfiguration: EventEmitter<any> = new EventEmitter();
    @Output() vcenterChanged: EventEmitter<any> = new EventEmitter();

    private subscribeHandler;
    private isTranslationready: boolean = false;
    private vcList: any [];

    private isLoading: boolean = false;
    private isRPDialogVisible: boolean = false;
    private entityType: string = '';
    private nodeToBeSelectedOnLoad: string = '';
    private datastores: any[] = [];
    private dataStoreLoading: boolean = true;
    private selectedDatastore: any;
    private skipNodeType: string = "cluster";
    private titleForRPDialog: string = '';

    ngOnInit() {
      this.titleForRPDialog = this.translate.instant('vcAdministration.resourcePool');
      this.getVCList();
    }

    ngOnChanges(changes) {
      const fleetConfigChange = changes['fleetConfig'];
      if(fleetConfigChange && this.fleetConfig){
        if((this.fleetConfig.resourcePoolId !== undefined && this.fleetConfig.resourcePoolId !== '')){
          this.getDatastores();
        }
        this.validateResourceConfiguration.emit({
          fleetConfig: this.fleetConfig
       })
      }
      const wizardOpenChange = changes['isWizardOpen'];
      if(wizardOpenChange){
        if(!this.isWizardOpen){
          this.isRPDialogVisible = false
        }
      }
    }

    constructor(public appState: AppState,
      public service: ICCService,
      private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
    }


    private getVCList() {
      this.vcList = [];
      this.isLoading = true;
      this.service.getVcList()
        .subscribe(
          (data:any) => {
            this.vcList = data;
            if(this.vcList.length === 1){
              if(this.fleetConfig.vcenterInstanceId  === undefined || this.fleetConfig.vcenterInstanceId === ''){
                this.fleetConfig.vcenterInstanceId = this.vcList[0].vcenter_instanceId;
                this.fleetConfig.vcenterName = this.vcList[0].name;
              }
            }
            this.isLoading = false;
          },
          error => {
            this.isLoading = false;
          }
        );
    }

    private onVCSelect(event) {
      if(this.fleetConfig.vcenterInstanceId !== event){
        this.fleetConfig.vcenterInstanceId = event;
        let selectedVC = _.find(this.vcList, function(vc){
          return vc.vcenter_instanceId === event;
        })
        if(selectedVC){
          this.fleetConfig.vcenterName = selectedVC.name;
        }
        this.vcenterChanged.emit();
      }
    }

    private onNameChanged(event){
      this.fleetConfig.name = event;
      this.validateResourceConfiguration.emit({
         fleetConfig: this.fleetConfig
      })
    }

    private showResourcePoolDialog(){
      this.isRPDialogVisible = false;
      this.isRPDialogVisible = true;
      this.entityType = "cluster";
    }

    private onResourcePoolSelected(event){
      this.fleetConfig.resourcePoolId = event.data.id;
      this.fleetConfig.clusterId = event.data.owner.value;
      this.fleetConfig.resourcePoolName = event.data.name;
      this.isRPDialogVisible = false;
      this.getDatastores();
      this.validateResourceConfiguration.emit({
        fleetConfig: this.fleetConfig
     })
    }

    private onRPDialogClose(event){
      this.isRPDialogVisible = false;
    }

    private removeResourcePool(){
      this.fleetConfig.resourcePoolId = '';
      this.fleetConfig.clusterId = '';
      this.fleetConfig.resourcePoolName = '';
      this.validateResourceConfiguration.emit({
        fleetConfig: this.fleetConfig
      })
    }

    private getDatastores(){
      this.dataStoreLoading = true;
      this.service.getDatastores(this.fleetConfig.vcenterInstanceId,this.fleetConfig.clusterId).subscribe(
        (datastores)=>{
          this.datastores = datastores;

          if(this.fleetConfig.dataStoreId !== undefined || this.fleetConfig.dataStoreId !== '' ){
            let me = this;
            this.selectedDatastore = _.find(this.datastores, function(datastore){
                return datastore.id === me.fleetConfig.dataStoreId;
            })
          }
          this.dataStoreLoading = false;
        },
        (error) => {
          console.log(error);
        }
      )
    }

    private onDataStoreSelected(event){
      if(event){
        this.selectedDatastore = event;
        this.fleetConfig.dataStoreId = event.id;
        this.fleetConfig.dataStoreName = event.name;
        this.selectedDatastore = event;
        this.validateResourceConfiguration.emit({
          fleetConfig: this.fleetConfig
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/steps/select-vc-dc.component.ts